import type { AxiosError, AxiosInstance } from 'axios'
import { isTimeoutError, isNetworkError } from './error-classification'
import { t } from 'i18next'

export function addErrorNormalizerInterceptor(instance: AxiosInstance): void {
  instance.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
      error.message = normalizeHttpError(error)
      return Promise.reject(error)
    }
  )
}

export function normalizeHttpError(error: unknown): string {
  if (isAxiosError(error)) {
    const timeoutSeconds = extractTimeoutSeconds(error)

    if (isTimeoutError(error)) {
      return t('ui-common:error.http.timeout', {
        seconds: timeoutSeconds
      })
    }

    if (isNetworkError(error)) {
      return t('ui-common:error.http.network', {
        seconds: timeoutSeconds
      })
    }

    if (error.response?.status) {
      return error.message || t('ui-common:error.http.unknown')
    }
  }

  if (error instanceof Error) {
    return error.message
  }

  return t('ui-common:error.http.unknown')
}

function extractTimeoutSeconds(error: unknown): number | null {
  if (isAxiosError(error) && typeof error.config?.timeout === 'number') {
    return Math.round(error.config.timeout / 1000)
  }
  return null
}

function isAxiosError(error: unknown): error is AxiosError {
  return (
    typeof error === 'object' &&
    error !== null &&
    'isAxiosError' in error &&
    error.isAxiosError === true
  )
}
